import React from 'react';
import EditarEgresos from '../../../components/insumos/egresos/EditarEgresos';

    const EditarEgresosPage: React.FC = () => {
  return (
    <div style={{ padding: '20px' , textAlign: 'center' , alignItems: 'center', justifyContent: 'center'}}>
      <EditarEgresos />
    </div>
  );
};

export default EditarEgresosPage;